export const MAX_STACKED_STATUS_WORKSPACES_LENGTH = 5;
